import { registerComponent } from "helpers";

registerComponent(
  "wyatt-filter-toggle",
  class WyattFilterToggle extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector("button");
      this.filters = document.querySelector("[data-filters-container]");
      this.isHidden = localStorage.getItem("hideFilters") === "true";

      if (this.isHidden) {
        this.hideFilters();
      }

      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick() {
      if (this.isHidden) {
        this.showFilters();
      } else {
        this.hideFilters();
      }
    }

    hideFilters() {
      this.filters.classList.add("hidden");
      this.isHidden = true;
      this.button.dataset.isHidden = this.isHidden;
      localStorage.setItem("hideFilters", this.isHidden);
    }

    showFilters() {
      this.filters.classList.remove("hidden");
      this.isHidden = false;
      this.button.dataset.isHidden = this.isHidden;
      localStorage.setItem("hideFilters", this.isHidden);
    }
  }
);
